import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

const returnSteps = [
  {
    number: "01",
    title: "Prepare your return",
    text: "Keep the item unworn, unwashed and in its original condition with all tags attached.",
  },
  {
    number: "02",
    title: "Pack it securely",
    text: "Use the original packaging when possible and include your order number inside the parcel.",
  },
  {
    number: "03",
    title: "Send and track",
    text: "Choose a tracked carrier and keep the receipt until your refund confirmation arrives.",
  },
];

function Returns() {
  const { brandName, contact } = siteConfig;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="returns">
      <header className="returns__hero">
        <p>Help / Returns</p>
        <h1>Changed your mind?</h1>
        <span>That’s okay. Here is what happens next.</span>
      </header>

      <section className="returns__intro" aria-labelledby="returns-heading">
        <p className="returns__eyebrow">
          {siteConfig.commerce.returnWindowDays}-day return window
        </p>
        <h2 id="returns-heading">A return should feel uncomplicated.</h2>
        <p>
          You may return eligible {brandName} items within {siteConfig.commerce.returnWindowDays} days of delivery.
          Products must be unworn, unwashed and returned with their original
          labels. Underwear, swimwear and other sealed hygiene items can only be
          returned when the protective seal remains intact.
        </p>
      </section>

      <section className="returns__steps" aria-label="Return steps">
        {returnSteps.map((step) => (
          <article key={step.number}>
            <span>{step.number}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </article>
        ))}
      </section>

      <section className="returns__details">
        <div className="returns__details-heading">
          <p className="returns__eyebrow">Before you send it</p>
          <h2>Good to know.</h2>
        </div>
        <div className="returns__accordions">
          <details open>
            <summary>Return costs</summary>
            <p>
              Return postage is paid by the customer unless an item is faulty
              or we sent the wrong product. We recommend a trackable service;
              parcels remain your responsibility until they arrive.
            </p>
          </details>
          <details>
            <summary>Refund timing</summary>
            <p>
              Once your parcel arrives, allow up to 10 business days for
              inspection. Approved refunds go to the original payment method;
              your bank may need a few additional days to display the credit.
            </p>
          </details>
          <details>
            <summary>Exchanges</summary>
            <p>
              Direct exchanges are not currently available. Return the original
              item for a refund and place a new order for the preferred size or
              color so it can reach you sooner.
            </p>
          </details>
          <details>
            <summary>Faulty or incorrect items</summary>
            <p>
              Contact our team before returning the item. Share your order
              number and clear photos so we can arrange the right solution and
              cover any necessary postage.
            </p>
          </details>
        </div>
      </section>

      <section className="returns__support">
        <div>
          <p className="returns__eyebrow">Need a hand?</p>
          <h2>We will work it out together.</h2>
        </div>
        <div>
          <p>
            Send your order number to <a href={`mailto:${contact.email}`}>{contact.email}</a>
            and our customer-care team will guide you.
          </p>
          <div className="returns__actions">
            <Link to="/contact" onClick={toTop}>Contact us</Link>
            <Link to="/shipping" onClick={toTop}>Shipping information</Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Returns;
